export const MAINTENANCE_DELEGATION_CAPABILITIES = Object.freeze([
    'ORG_CONFIG_VIEW',
    'ORG_CONFIG_MANAGE',
    'ORG_IDENTITY_VIEW',
    'ORG_IDENTITY_MANAGE',
    'ORG_AUDIT_VIEW',
    'ORG_LEGAL_HOLD_MANAGE',
    'ORG_DATA_VIEW',
    'ORG_DATA_CORRECT',
    'ORG_IMPORT_RETRY',
    'ORG_RECONCILIATION_VIEW',
    'ORG_RECONCILIATION_MANAGE',
    'ORG_REPORT_VIEW',
    'ORG_REPORT_RUN',
    'ORG_FINANCIAL_EXPORT',
    'ORG_ACCESS_INSPECT',
]);
export const MAINTENANCE_DELEGATION_PURPOSES = Object.freeze([
    'FAILED_IMPORT_INVESTIGATION',
    'DATA_MIGRATION',
    'CONFIGURATION_CORRECTION',
    'CALCULATION_DEFECT_INVESTIGATION',
    'MARKET_DATA_MAPPING_REPAIR',
    'RECONCILIATION_SUPPORT',
    'ORGANIZATION_ADMINISTRATION_ASSISTANCE',
    'PRODUCTION_REMEDIATION_VALIDATION',
    'AUDIT_SUPPORT',
    'ACCESS_TROUBLESHOOTING',
]);
export const LEGACY_MAINTENANCE_DELEGATION_POLICY_VERSION = 'maintenance-delegation-legacy-read-only-v1';
export const MUTATING_MAINTENANCE_CAPABILITIES = Object.freeze([
    'ORG_CONFIG_MANAGE',
    'ORG_IDENTITY_MANAGE',
    'ORG_LEGAL_HOLD_MANAGE',
    'ORG_DATA_CORRECT',
    'ORG_IMPORT_RETRY',
    'ORG_RECONCILIATION_MANAGE',
    'ORG_REPORT_RUN',
    'ORG_FINANCIAL_EXPORT',
]);
export function validateMaintenanceDelegationGrant(grant) {
    const errors = [];
    if (!grant.delegationId.trim())
        errors.push('delegationId is required');
    if (!grant.supportUserIdentityId.trim())
        errors.push('supportUserIdentityId is required');
    if (!grant.scope.organizationId.trim())
        errors.push('organizationId is required');
    if (!grant.justification.trim())
        errors.push('justification is required');
    if (!grant.ticketReference.trim())
        errors.push('ticketReference is required');
    if (grant.requiredAal !== 'AAL2')
        errors.push('maintenance delegation requires AAL2');
    if (grant.capabilities.length === 0)
        errors.push('at least one capability is required');
    if (grant.allowedOperationIds.length === 0)
        errors.push('at least one operation is required');
    if (grant.expiresAt <= grant.effectiveFrom)
        errors.push('expiresAt must follow effectiveFrom');
    if (new Set(grant.capabilities).size !== grant.capabilities.length) {
        errors.push('capabilities contain duplicates');
    }
    if (new Set(grant.allowedOperationIds).size !== grant.allowedOperationIds.length) {
        errors.push('allowedOperationIds contain duplicates');
    }
    const resourceIds = grant.scope.resourceIds ?? [];
    if (resourceIds.some((id) => typeof id !== 'string' || !id.trim())) {
        errors.push('resourceIds entries must be non-empty strings');
    }
    if (new Set(resourceIds).size !== resourceIds.length) {
        errors.push('resourceIds contain duplicates');
    }
    return errors;
}
export function validateMaintenanceDelegationPolicy() {
    const errors = [];
    const capabilities = new Set(MAINTENANCE_DELEGATION_CAPABILITIES);
    if (capabilities.size !== MAINTENANCE_DELEGATION_CAPABILITIES.length) {
        errors.push('maintenance delegation capabilities contain duplicates');
    }
    if (new Set(MAINTENANCE_DELEGATION_PURPOSES).size !== MAINTENANCE_DELEGATION_PURPOSES.length) {
        errors.push('maintenance delegation purposes contain duplicates');
    }
    for (const capability of MUTATING_MAINTENANCE_CAPABILITIES) {
        if (!capabilities.has(capability))
            errors.push(`unknown mutating maintenance capability ${capability}`);
    }
    if (!LEGACY_MAINTENANCE_DELEGATION_POLICY_VERSION.includes('read-only')) {
        errors.push('legacy maintenance delegation policy must remain explicitly read-only');
    }
    return errors;
}
